export const WATCHLIST_KEY = 'watchlist';
export const PORTFOLIO_KEY = 'portfolio';
export const IDENTIFIER_COLUMNS = ['sedol', 'cusip', 'isin'];
export const MSI_V2_STAGED_IDENTIFIER_COLUMNS = [
    ...IDENTIFIER_COLUMNS,
    'ticker',
    'bloomberg_ticker',
    'openfigi_figi',
    'openfigi_composite',
    'openfigi_share_class',
    'barra_localid',
    'barrid',
    'axioma_id',
];
export const PORTFOLIO_IDENTIFIER_COLUMNS = [...IDENTIFIER_COLUMNS, 'ticker', 'bloomberg_ticker', 'cognive_id'];
export function normalizeIdentifierHeader(value) {
    const header = String(value ?? '').normalize('NFC').trim().replace(/\s+/g, ' ').toLowerCase();
    return ['bbg', 'bloomberg', 'bloomberg ticker'].includes(header) ? 'bloomberg_ticker' : header;
}

export function detectIdentifierColumns(headerColumns = [], supportedIdentifiers = IDENTIFIER_COLUMNS) {
    const normalized = (headerColumns || []).map(normalizeIdentifierHeader);
    return supportedIdentifiers.filter((identifierColumn) => normalized.includes(identifierColumn));
}

export function validateExactlyOneUploadIdentifierColumn(headerColumns = [], supportedIdentifiers = IDENTIFIER_COLUMNS) {
    const matched = detectIdentifierColumns(headerColumns, supportedIdentifiers);
    if (!matched.length) {
        throw new Error(`Missing required identifier column. Provide exactly one of: ${supportedIdentifiers.join(', ')}`);
    }
    if (matched.length > 1) {
        throw new Error(`Only one identifier column is allowed. Found: ${matched.join(', ')}`);
    }
    return matched[0];
}

export const templateConfig = {
    watchlist: {
        csv: [
            ['sedol', 'Sector', 'Analyst', 'beta_BBG(optional)'],
            ['2046251', '', 'Alex', '1.12'],
            ['2310967', 'Technology', '', '1.01'],
            ['2553249', 'Financials', 'Morgan', '0.88'],
        ],
        excel: [
            ['sedol', 'Sector', 'Analyst', 'beta_BBG(optional)'],
            ['2046251', '', 'Alex', '1.12'],
            ['2310967', 'Technology', '', '1.01'],
            ['2553249', 'Financials', 'Morgan', '0.88'],
        ]
    },
    posSizing: {
        csv: [
            ['cusip', 'trade_idea'],
            ['037833100', '100'],
            ['594918104', '-50'],
        ],
        excel: [
            ['cusip', 'trade_idea'],
            ['037833100', '100'],
            ['594918104', '-50'],
        ]
    },
    portfolio: {
        csv: [
            ['sedol', 'quantity'],
            ['2046251', '100'],
            ['2310967', '50'],
            ['2553249', '75'],
        ],
        excel: [
            ['sedol', 'quantity'],
            ['2046251', '100'],
            ['2310967', '50'],
            ['2553249', '75'],
        ]
    }
};

export const requiredColumnsUploadConfig = {
    watchlist: [],
    portfolio: ['quantity'],
    posSizing: ["trade_idea"],
};
